import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export enum Authorization {
  Finance = 'finance',
  LaborContract = 'laborContract',
  Personnel = 'personnel'
}

export type Company = {
  __typename?: 'Company';
  companyAuthorizations?: Maybe<Array<CompanyAuthorization>>;
  contractors: Array<Contractor>;
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  reports: Array<FileObjectType>;
  taxId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  users: Array<User>;
};

export type CompanyAuthorization = {
  __typename?: 'CompanyAuthorization';
  authorization: Authorization;
  company?: Maybe<Company>;
  enabled?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  remindDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type CompanyAuthorizationInputType = {
  authorization?: Maybe<Authorization>;
  enabled?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  remindDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type CompanyInputType = {
  companyAuthorizations?: Maybe<Array<CompanyAuthorizationInputType>>;
  enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
};

export type ConfigInputType = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type ConfigObjectType = {
  __typename?: 'ConfigObjectType';
  id: Scalars['Int'];
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Contractor = {
  __typename?: 'Contractor';
  address?: Maybe<Scalars['String']>;
  bankAccountName?: Maybe<Scalars['String']>;
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
  company: Company;
  companyId?: Maybe<Scalars['Int']>;
  contactAddress?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  idBackFile?: Maybe<FileObjectType>;
  idFrontFile?: Maybe<FileObjectType>;
  idNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  noInsurance?: Maybe<Scalars['Boolean']>;
  passbookFile?: Maybe<FileObjectType>;
  phone?: Maybe<Scalars['String']>;
  taxClassification?: Maybe<TaxClassificationEnum>;
  updatedAt: Scalars['DateTime'];
};

export type ContractorInputType = {
  address?: Maybe<Scalars['String']>;
  bankAccountName?: Maybe<Scalars['String']>;
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  contactAddress?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  idBackFileId?: Maybe<Scalars['String']>;
  idFrontFileId?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  noInsurance?: Maybe<Scalars['Boolean']>;
  passbookFileId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  taxClassification?: Maybe<TaxClassificationEnum>;
};

export type CreateLaborContractDto = {
  amount?: Maybe<Scalars['Int']>;
  assigneeId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  contractContent?: Maybe<Scalars['String']>;
  contractEndDate?: Maybe<Scalars['DateTime']>;
  contractStartDate?: Maybe<Scalars['DateTime']>;
  contractorAddress?: Maybe<Scalars['String']>;
  contractorBankAccountName?: Maybe<Scalars['String']>;
  contractorBankAccountNumber?: Maybe<Scalars['String']>;
  contractorBankCode?: Maybe<Scalars['String']>;
  contractorContactAddress?: Maybe<Scalars['String']>;
  contractorEmail?: Maybe<Scalars['String']>;
  contractorId?: Maybe<Scalars['Int']>;
  contractorIdNumber?: Maybe<Scalars['String']>;
  contractorName?: Maybe<Scalars['String']>;
  contractorNationality?: Maybe<Scalars['String']>;
  contractorNoInsurance?: Maybe<Scalars['Boolean']>;
  contractorPhone?: Maybe<Scalars['String']>;
  contractorTaxClassification?: Maybe<TaxClassificationEnum>;
  date?: Maybe<Scalars['DateTime']>;
  editable?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  idBackFileId?: Maybe<Scalars['String']>;
  idFrontFileId?: Maybe<Scalars['String']>;
  incomeType?: Maybe<IncomeTypeEnum>;
  name: Scalars['String'];
  operator?: Maybe<Scalars['String']>;
  operatorPhone?: Maybe<Scalars['String']>;
  passbookFileId?: Maybe<Scalars['String']>;
  payDate?: Maybe<Scalars['DateTime']>;
  paymentMethod?: Maybe<PaymentMethodEnum>;
  signatureFileId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<LaborContractStatusEnum>;
  taxPaid?: Maybe<Scalars['Boolean']>;
};

export type CreateUserDto = {
  authorizations: Array<Authorization>;
  /** Array of IDs */
  companies: Array<Scalars['Int']>;
  disabled?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  roles: Array<RoleEnum>;
};

export enum DayTypeEnum {
  Holiday = 'holiday',
  OfficialHoliday = 'officialHoliday',
  Restday = 'restday',
  Workday = 'workday'
}

export type Dependent = {
  __typename?: 'Dependent';
  birthday?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  employee?: Maybe<Employee>;
  gender?: Maybe<GenderEnum>;
  id: Scalars['Int'];
  idNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  relation?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type DependentInputType = {
  birthday?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<GenderEnum>;
  idNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  relation?: Maybe<Scalars['String']>;
};

export enum EmployStateEnum {
  Employed = 'employed',
  Pending = 'pending',
  Resigned = 'resigned'
}

export type Employee = {
  __typename?: 'Employee';
  accountNumber?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  bankCode?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateTime']>;
  code?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  createdAt: Scalars['DateTime'];
  dependents?: Maybe<Array<Dependent>>;
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  gender: GenderEnum;
  healthInsuranceAmount?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  idNumber?: Maybe<Scalars['String']>;
  identity?: Maybe<IdentityEnum>;
  laborInsuranceAmount?: Maybe<Scalars['Int']>;
  leaveDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  pensionAmount?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  pickup?: Maybe<Scalars['Int']>;
  prepaid?: Maybe<Scalars['Boolean']>;
  salaryItems?: Maybe<Array<SalaryItem>>;
  state?: Maybe<EmployStateEnum>;
  type?: Maybe<WorkTypeEnum>;
  updatedAt: Scalars['DateTime'];
};

export type EmployeeInputType = {
  accountNumber?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  bankCode?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateTime']>;
  code?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  dependents?: Maybe<Array<DependentInputType>>;
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  gender?: Maybe<GenderEnum>;
  healthInsuranceAmount?: Maybe<Scalars['Int']>;
  idNumber?: Maybe<Scalars['String']>;
  identity?: Maybe<IdentityEnum>;
  laborInsuranceAmount?: Maybe<Scalars['Int']>;
  leaveDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  pensionAmount?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  pickup?: Maybe<Scalars['Int']>;
  prepaid?: Maybe<Scalars['Boolean']>;
  salaryItems?: Maybe<Array<SalaryItemInputType>>;
  state?: Maybe<EmployStateEnum>;
  type?: Maybe<WorkTypeEnum>;
};

export type FileObjectType = {
  __typename?: 'FileObjectType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  mimetype: Scalars['String'];
  name: Scalars['String'];
  type?: Maybe<FileTypeEnum>;
  uri: Scalars['String'];
};

export enum FileTypeEnum {
  ReportFile = 'reportFile',
  Signature = 'signature'
}

export enum GenderEnum {
  Female = 'female',
  Male = 'male'
}

export enum IdentityEnum {
  Employee = 'employee',
  Employer = 'employer'
}

export enum IncomeTypeEnum {
  A_9a = 'a_9a',
  A_9b = 'a_9b',
  A_50 = 'a_50',
  A_92 = 'a_92'
}

export type LaborContract = {
  __typename?: 'LaborContract';
  amount?: Maybe<Scalars['Float']>;
  assigneeId?: Maybe<Scalars['Int']>;
  company: Company;
  companyId?: Maybe<Scalars['Int']>;
  contractContent?: Maybe<Scalars['String']>;
  contractEndDate?: Maybe<Scalars['DateTime']>;
  contractStartDate?: Maybe<Scalars['DateTime']>;
  contractorAddress?: Maybe<Scalars['String']>;
  contractorBankAccountName?: Maybe<Scalars['String']>;
  contractorBankAccountNumber?: Maybe<Scalars['String']>;
  contractorBankCode?: Maybe<Scalars['String']>;
  contractorContactAddress?: Maybe<Scalars['String']>;
  contractorEmail?: Maybe<Scalars['String']>;
  contractorIdNumber?: Maybe<Scalars['String']>;
  contractorName?: Maybe<Scalars['String']>;
  contractorNationality?: Maybe<Scalars['String']>;
  contractorNoInsurance?: Maybe<Scalars['Boolean']>;
  contractorPhone?: Maybe<Scalars['String']>;
  contractorTaxClassification?: Maybe<TaxClassificationEnum>;
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  editable: Scalars['Boolean'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  idBackFile?: Maybe<FileObjectType>;
  idFrontFile?: Maybe<FileObjectType>;
  incomeType?: Maybe<IncomeTypeEnum>;
  name: Scalars['String'];
  operator?: Maybe<Scalars['String']>;
  operatorPhone?: Maybe<Scalars['String']>;
  passbookFile?: Maybe<FileObjectType>;
  payDate?: Maybe<Scalars['DateTime']>;
  paymentMethod?: Maybe<PaymentMethodEnum>;
  signatureFile?: Maybe<FileObjectType>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<LaborContractStatusEnum>;
  taxPaid: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  uuid?: Maybe<Scalars['String']>;
};

export enum LaborContractStatusEnum {
  Draft = 'draft',
  Expired = 'expired',
  Finished = 'finished',
  Signed = 'signed',
  Unsigned = 'unsigned'
}

export type Leave = {
  __typename?: 'Leave';
  company?: Maybe<Company>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  limit?: Maybe<Scalars['String']>;
  salaryStandard?: Maybe<SalaryStandardEnum>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type LeaveInputType = {
  companyId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['String']>;
  salaryStandard?: Maybe<SalaryStandardEnum>;
  title?: Maybe<Scalars['String']>;
};

export type LeaveItem = {
  __typename?: 'LeaveItem';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  employee: Employee;
  endTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  leave: Leave;
  restHours?: Maybe<Scalars['Float']>;
  salaryMultiple?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type LeaveItemInputType = {
  description?: Maybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  endTime?: Maybe<Scalars['DateTime']>;
  leaveId: Scalars['Int'];
  restHours?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['DateTime']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createCompany: Company;
  createContractor: Contractor;
  createEmployee: Employee;
  createLaborContract: LaborContract;
  createLeave: Leave;
  createLeaveItem: LeaveItem;
  createSalaryExtend: SalaryExtend;
  createSalaryGroup: SalaryGroup;
  createUser: User;
  createWorkRecord: WorkRecord;
  duplicateLaborContract: LaborContract;
  noop: Scalars['Int'];
  removeCompany: Scalars['Int'];
  removeContractor: Scalars['Int'];
  removeFile: Scalars['ID'];
  removeLaborContract: Scalars['Int'];
  removeLeave: Scalars['Int'];
  removeLeaveItem: Scalars['Int'];
  removeSalaryExtend: Scalars['Int'];
  removeSalaryGroup: Scalars['Int'];
  removeUser: Scalars['Int'];
  removeWorkRecord: Scalars['Int'];
  sendSalaries: Scalars['Int'];
  setPublicLaborContractSignature: PublicLaborContract;
  submitPublicLaborContract: PublicLaborContract;
  updateCompany: Company;
  updateContractor: Contractor;
  updateEmployee: Employee;
  updateLaborContract: LaborContract;
  updateLeave: Leave;
  updateLeaveItem: LeaveItem;
  updatePublicLaborContract: PublicLaborContract;
  updateSalaryExtend: SalaryExtend;
  updateUser: User;
  updateWorkRecord: WorkRecord;
  upsertConfig: ConfigObjectType;
};


export type MutationCreateCompanyArgs = {
  company: CompanyInputType;
};


export type MutationCreateContractorArgs = {
  contractor: ContractorInputType;
};


export type MutationCreateEmployeeArgs = {
  employee: EmployeeInputType;
};


export type MutationCreateLaborContractArgs = {
  laborContract: CreateLaborContractDto;
};


export type MutationCreateLeaveArgs = {
  leave: LeaveInputType;
};


export type MutationCreateLeaveItemArgs = {
  leaveItem: LeaveItemInputType;
};


export type MutationCreateSalaryExtendArgs = {
  salaryExtend: SalaryExtendInputType;
};


export type MutationCreateSalaryGroupArgs = {
  salaryGroup: SalaryGroupInputType;
};


export type MutationCreateUserArgs = {
  user: CreateUserDto;
};


export type MutationCreateWorkRecordArgs = {
  workRecord: WorkRecordInputType;
};


export type MutationDuplicateLaborContractArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveCompanyArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveContractorArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveFileArgs = {
  id: Scalars['String'];
};


export type MutationRemoveLaborContractArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveLeaveArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveLeaveItemArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveSalaryExtendArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveSalaryGroupArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveUserArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveWorkRecordArgs = {
  id: Scalars['Int'];
};


export type MutationSendSalariesArgs = {
  body: Scalars['String'];
  salaryIds: Array<Scalars['Int']>;
  subject: Scalars['String'];
};


export type MutationSetPublicLaborContractSignatureArgs = {
  signatureFileId: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationSubmitPublicLaborContractArgs = {
  status: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationUpdateCompanyArgs = {
  company: CompanyInputType;
  id: Scalars['Int'];
};


export type MutationUpdateContractorArgs = {
  contractor: ContractorInputType;
  id: Scalars['Int'];
};


export type MutationUpdateEmployeeArgs = {
  employee: EmployeeInputType;
  id: Scalars['Int'];
};


export type MutationUpdateLaborContractArgs = {
  id: Scalars['Int'];
  laborContract: UpdateLaborContractDto;
};


export type MutationUpdateLeaveArgs = {
  id: Scalars['Int'];
  leave: LeaveInputType;
};


export type MutationUpdateLeaveItemArgs = {
  id: Scalars['Int'];
  leaveItem: LeaveItemInputType;
};


export type MutationUpdatePublicLaborContractArgs = {
  publicLaborContract: PublicLaborContractUpdateDto;
  uuid: Scalars['String'];
};


export type MutationUpdateSalaryExtendArgs = {
  id: Scalars['Int'];
  salaryExtend: SalaryExtendInputType;
};


export type MutationUpdateUserArgs = {
  id: Scalars['Int'];
  user: UpdateUserDto;
};


export type MutationUpdateWorkRecordArgs = {
  id: Scalars['Int'];
  workRecord: WorkRecordInputType;
};


export type MutationUpsertConfigArgs = {
  config: ConfigInputType;
  key: Scalars['String'];
};

export enum PaymentMethodEnum {
  Cash = 'cash',
  Check = 'check',
  Coupon = 'coupon',
  Transfer = 'transfer'
}

export type PublicLaborContract = {
  __typename?: 'PublicLaborContract';
  amount?: Maybe<Scalars['Float']>;
  assigneeId?: Maybe<Scalars['Int']>;
  company: Company;
  companyId?: Maybe<Scalars['Int']>;
  contractContent?: Maybe<Scalars['String']>;
  contractEndDate?: Maybe<Scalars['DateTime']>;
  contractStartDate?: Maybe<Scalars['DateTime']>;
  contractorAddress?: Maybe<Scalars['String']>;
  contractorBankAccountName?: Maybe<Scalars['String']>;
  contractorBankAccountNumber?: Maybe<Scalars['String']>;
  contractorBankCode?: Maybe<Scalars['String']>;
  contractorContactAddress?: Maybe<Scalars['String']>;
  contractorEmail?: Maybe<Scalars['String']>;
  contractorIdNumber?: Maybe<Scalars['String']>;
  contractorName?: Maybe<Scalars['String']>;
  contractorNationality?: Maybe<Scalars['String']>;
  contractorNoInsurance?: Maybe<Scalars['Boolean']>;
  contractorPhone?: Maybe<Scalars['String']>;
  contractorTaxClassification?: Maybe<TaxClassificationEnum>;
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  editable: Scalars['Boolean'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  idBackFile?: Maybe<FileObjectType>;
  idFrontFile?: Maybe<FileObjectType>;
  incomeType?: Maybe<IncomeTypeEnum>;
  name: Scalars['String'];
  operator?: Maybe<Scalars['String']>;
  operatorPhone?: Maybe<Scalars['String']>;
  passbookFile?: Maybe<FileObjectType>;
  payDate?: Maybe<Scalars['DateTime']>;
  paymentMethod?: Maybe<PaymentMethodEnum>;
  signatureFile?: Maybe<FileObjectType>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<LaborContractStatusEnum>;
  taxPaid: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  uuid?: Maybe<Scalars['String']>;
};

export type PublicLaborContractUpdateDto = {
  contractorAddress?: Maybe<Scalars['String']>;
  contractorBankAccountName?: Maybe<Scalars['String']>;
  contractorBankAccountNumber?: Maybe<Scalars['String']>;
  contractorBankCode?: Maybe<Scalars['String']>;
  contractorContactAddress?: Maybe<Scalars['String']>;
  contractorEmail?: Maybe<Scalars['String']>;
  contractorIdNumber?: Maybe<Scalars['String']>;
  contractorName?: Maybe<Scalars['String']>;
  contractorNationality?: Maybe<Scalars['String']>;
  contractorNoInsurance?: Maybe<Scalars['Boolean']>;
  contractorPhone?: Maybe<Scalars['String']>;
  contractorTaxClassification?: Maybe<TaxClassificationEnum>;
  endDate?: Maybe<Scalars['DateTime']>;
  idBackFileId?: Maybe<Scalars['String']>;
  idFrontFileId?: Maybe<Scalars['String']>;
  operator?: Maybe<Scalars['String']>;
  operatorPhone?: Maybe<Scalars['String']>;
  passbookFileId?: Maybe<Scalars['String']>;
  signatureFileId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type Query = {
  __typename?: 'Query';
  calculateSalaries: Array<Salary>;
  companies: Array<Company>;
  company: Company;
  config: ConfigObjectType;
  contractor: Contractor;
  contractors: Array<Contractor>;
  employee: Employee;
  employees: Array<Employee>;
  laborContract: LaborContract;
  laborContracts: Array<LaborContract>;
  leaveItems: Array<LeaveItem>;
  leaves: Array<Leave>;
  me: User;
  publicLaborContract: PublicLaborContract;
  salaries: Array<Salary>;
  salaryExtends: Array<SalaryExtend>;
  salaryGroups: Array<SalaryGroup>;
  user: User;
  users: Array<User>;
  workRecords: Array<WorkRecord>;
};


export type QueryCalculateSalariesArgs = {
  companyId: Scalars['Int'];
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  yearMonth: Scalars['String'];
};


export type QueryCompanyArgs = {
  id: Scalars['Int'];
};


export type QueryConfigArgs = {
  key: Scalars['String'];
};


export type QueryContractorArgs = {
  id: Scalars['Int'];
};


export type QueryEmployeeArgs = {
  id: Scalars['Int'];
};


export type QueryLaborContractArgs = {
  id: Scalars['Int'];
};


export type QueryPublicLaborContractArgs = {
  uuid: Scalars['String'];
};


export type QueryUserArgs = {
  id: Scalars['Int'];
};

export enum RoleEnum {
  Admin = 'admin',
  Manager = 'manager'
}

export type Salary = {
  __typename?: 'Salary';
  createdAt: Scalars['DateTime'];
  employee?: Maybe<Employee>;
  id: Scalars['Int'];
  salaryGroup?: Maybe<SalaryGroup>;
  salaryItems?: Maybe<Array<SalaryItem>>;
  updatedAt: Scalars['DateTime'];
};

export type SalaryExtend = {
  __typename?: 'SalaryExtend';
  amount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  employee?: Maybe<Employee>;
  id: Scalars['Int'];
  subject?: Maybe<Scalars['String']>;
  type?: Maybe<SalaryItemTypeEnum>;
  updatedAt: Scalars['DateTime'];
  yearMonth?: Maybe<Scalars['String']>;
};

export type SalaryExtendInputType = {
  amount?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['Int']>;
  subject?: Maybe<Scalars['String']>;
  type?: Maybe<SalaryItemTypeEnum>;
  yearMonth?: Maybe<Scalars['String']>;
};

export type SalaryGroup = {
  __typename?: 'SalaryGroup';
  company?: Maybe<Company>;
  createdAt: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  payDate?: Maybe<Scalars['DateTime']>;
  salaries?: Maybe<Array<Salary>>;
  startDate?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  yearMonth?: Maybe<Scalars['String']>;
};

export type SalaryGroupInputType = {
  companyId?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['DateTime']>;
  payDate?: Maybe<Scalars['DateTime']>;
  salaries?: Maybe<Array<SalaryInputType>>;
  startDate?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  yearMonth?: Maybe<Scalars['String']>;
};

export type SalaryInputType = {
  employeeId: Scalars['Int'];
  salaryItems?: Maybe<Array<SalaryItemInputType>>;
};

export type SalaryItem = {
  __typename?: 'SalaryItem';
  amount?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  type?: Maybe<SalaryItemTypeEnum>;
};

export type SalaryItemInputType = {
  amount?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<SalaryItemTypeEnum>;
};

export enum SalaryItemTypeEnum {
  Company = 'company',
  Minus = 'minus',
  Normal = 'normal',
  Plus = 'plus'
}

export enum SalaryStandardEnum {
  All = 'all',
  Half = 'half',
  None = 'none',
  Other = 'other'
}

export enum TaxClassificationEnum {
  Citizen = 'citizen',
  NonResidentAlien = 'nonResidentAlien',
  ResidentAlien = 'residentAlien'
}

export type UpdateLaborContractDto = {
  amount?: Maybe<Scalars['Int']>;
  assigneeId?: Maybe<Scalars['Int']>;
  contractContent?: Maybe<Scalars['String']>;
  contractEndDate?: Maybe<Scalars['DateTime']>;
  contractStartDate?: Maybe<Scalars['DateTime']>;
  contractorAddress?: Maybe<Scalars['String']>;
  contractorBankAccountName?: Maybe<Scalars['String']>;
  contractorBankAccountNumber?: Maybe<Scalars['String']>;
  contractorBankCode?: Maybe<Scalars['String']>;
  contractorContactAddress?: Maybe<Scalars['String']>;
  contractorEmail?: Maybe<Scalars['String']>;
  contractorId?: Maybe<Scalars['Int']>;
  contractorIdNumber?: Maybe<Scalars['String']>;
  contractorName?: Maybe<Scalars['String']>;
  contractorNationality?: Maybe<Scalars['String']>;
  contractorNoInsurance?: Maybe<Scalars['Boolean']>;
  contractorPhone?: Maybe<Scalars['String']>;
  contractorTaxClassification?: Maybe<TaxClassificationEnum>;
  date?: Maybe<Scalars['DateTime']>;
  editable?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  idBackFileId?: Maybe<Scalars['String']>;
  idFrontFileId?: Maybe<Scalars['String']>;
  incomeType?: Maybe<IncomeTypeEnum>;
  name?: Maybe<Scalars['String']>;
  operator?: Maybe<Scalars['String']>;
  operatorPhone?: Maybe<Scalars['String']>;
  passbookFileId?: Maybe<Scalars['String']>;
  payDate?: Maybe<Scalars['DateTime']>;
  paymentMethod?: Maybe<PaymentMethodEnum>;
  signatureFileId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<LaborContractStatusEnum>;
  taxPaid?: Maybe<Scalars['Boolean']>;
};

export type UpdateUserDto = {
  authorizations?: Maybe<Array<Authorization>>;
  /** Array of IDs */
  companies?: Maybe<Array<Scalars['Int']>>;
  disabled?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<RoleEnum>>;
};

export type User = {
  __typename?: 'User';
  authorizations: Array<Authorization>;
  companies: Array<Company>;
  createdAt: Scalars['DateTime'];
  disabled: Scalars['Boolean'];
  email: Scalars['String'];
  googleId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  roles: Array<RoleEnum>;
  updatedAt: Scalars['DateTime'];
};

export type WorkRecord = {
  __typename?: 'WorkRecord';
  createdAt: Scalars['DateTime'];
  dayType?: Maybe<DayTypeEnum>;
  description?: Maybe<Scalars['String']>;
  employee?: Maybe<Employee>;
  endTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  restHours?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type WorkRecordInputType = {
  dayType?: Maybe<DayTypeEnum>;
  description?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  restHours?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['DateTime']>;
};

export enum WorkTypeEnum {
  Hourly = 'hourly',
  Monthly = 'monthly'
}

export type CreateCompanyMutationVariables = Exact<{
  company: CompanyInputType;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'Company', id: number } };

export type GetCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', createdAt: any, enabled: boolean, id: number, name: string, taxId?: string | null | undefined, updatedAt: any, companyAuthorizations?: Array<{ __typename?: 'CompanyAuthorization', authorization: Authorization, startDate?: any | null | undefined, endDate?: any | null | undefined, remindDate?: any | null | undefined, enabled?: boolean | null | undefined }> | null | undefined }> };

export type RemoveCompanyMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveCompanyMutation = { __typename?: 'Mutation', removeCompany: number };

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['Int'];
  company: CompanyInputType;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', id: number } };

export type GetConfigQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type GetConfigQuery = { __typename?: 'Query', config: { __typename?: 'ConfigObjectType', id: number, key: string, value: string } };

export type UpsertConfigMutationVariables = Exact<{
  key: Scalars['String'];
  config: ConfigInputType;
}>;


export type UpsertConfigMutation = { __typename?: 'Mutation', upsertConfig: { __typename?: 'ConfigObjectType', id: number, key: string, value: string } };

export type CreateContractorMutationVariables = Exact<{
  contractor: ContractorInputType;
}>;


export type CreateContractorMutation = { __typename?: 'Mutation', createContractor: { __typename?: 'Contractor', id: number, name?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, idNumber?: string | null | undefined } };

export type GetContractorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractorsQuery = { __typename?: 'Query', contractors: Array<{ __typename?: 'Contractor', id: number, name?: string | null | undefined, address?: string | null | undefined, contactAddress?: string | null | undefined, nationality?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, idNumber?: string | null | undefined, taxClassification?: TaxClassificationEnum | null | undefined, noInsurance?: boolean | null | undefined, bankCode?: string | null | undefined, bankAccountNumber?: string | null | undefined, bankAccountName?: string | null | undefined, company: { __typename?: 'Company', id: number, name: string }, idBackFile?: { __typename?: 'FileObjectType', id: string, uri: string } | null | undefined, idFrontFile?: { __typename?: 'FileObjectType', id: string, uri: string } | null | undefined, passbookFile?: { __typename?: 'FileObjectType', id: string, uri: string } | null | undefined }> };

export type RemoveContractorMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveContractorMutation = { __typename?: 'Mutation', removeContractor: number };

export type UpdateContractorMutationVariables = Exact<{
  contractor: ContractorInputType;
  id: Scalars['Int'];
}>;


export type UpdateContractorMutation = { __typename?: 'Mutation', updateContractor: { __typename?: 'Contractor', id: number, name?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, idNumber?: string | null | undefined, taxClassification?: TaxClassificationEnum | null | undefined } };

export type CreateEmployeeMutationVariables = Exact<{
  employee: EmployeeInputType;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee: { __typename?: 'Employee', id: number } };

export type GetEmployeeQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetEmployeeQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', id: number, createdAt: any, updatedAt: any, code?: string | null | undefined, name?: string | null | undefined, gender: GenderEnum, nationality?: string | null | undefined, birthday?: any | null | undefined, idNumber?: string | null | undefined, state?: EmployStateEnum | null | undefined, arrivalDate?: any | null | undefined, leaveDate?: any | null | undefined, email?: string | null | undefined, address?: string | null | undefined, phone?: string | null | undefined, bankCode?: string | null | undefined, accountNumber?: string | null | undefined, prepaid?: boolean | null | undefined, identity?: IdentityEnum | null | undefined, type?: WorkTypeEnum | null | undefined, pickup?: number | null | undefined, description?: string | null | undefined, laborInsuranceAmount?: number | null | undefined, healthInsuranceAmount?: number | null | undefined, pensionAmount?: number | null | undefined, disabled?: boolean | null | undefined, salaryItems?: Array<{ __typename?: 'SalaryItem', title?: string | null | undefined, amount?: number | null | undefined, type?: SalaryItemTypeEnum | null | undefined }> | null | undefined, dependents?: Array<{ __typename?: 'Dependent', name?: string | null | undefined, relation?: string | null | undefined, idNumber?: string | null | undefined, gender?: GenderEnum | null | undefined, nationality?: string | null | undefined, birthday?: any | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id: number, name: string } | null | undefined } };

export type GetEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployeesQuery = { __typename?: 'Query', employees: Array<{ __typename?: 'Employee', id: number, createdAt: any, updatedAt: any, code?: string | null | undefined, name?: string | null | undefined, gender: GenderEnum, nationality?: string | null | undefined, birthday?: any | null | undefined, idNumber?: string | null | undefined, state?: EmployStateEnum | null | undefined, arrivalDate?: any | null | undefined, leaveDate?: any | null | undefined, email?: string | null | undefined, address?: string | null | undefined, phone?: string | null | undefined, bankCode?: string | null | undefined, accountNumber?: string | null | undefined, identity?: IdentityEnum | null | undefined, type?: WorkTypeEnum | null | undefined, pickup?: number | null | undefined, description?: string | null | undefined, laborInsuranceAmount?: number | null | undefined, healthInsuranceAmount?: number | null | undefined, pensionAmount?: number | null | undefined, disabled?: boolean | null | undefined, salaryItems?: Array<{ __typename?: 'SalaryItem', title?: string | null | undefined, amount?: number | null | undefined, type?: SalaryItemTypeEnum | null | undefined }> | null | undefined, dependents?: Array<{ __typename?: 'Dependent', name?: string | null | undefined, relation?: string | null | undefined, idNumber?: string | null | undefined, gender?: GenderEnum | null | undefined, nationality?: string | null | undefined, birthday?: any | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id: number, name: string } | null | undefined }> };

export type UpdateEmployeeMutationVariables = Exact<{
  employee: EmployeeInputType;
  id: Scalars['Int'];
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee: { __typename?: 'Employee', id: number } };

export type GetPublicLaborContractQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type GetPublicLaborContractQuery = { __typename?: 'Query', publicLaborContract: { __typename?: 'PublicLaborContract', id: number, createdAt: any, updatedAt: any, name: string, status?: LaborContractStatusEnum | null | undefined, date?: any | null | undefined, payDate?: any | null | undefined, contractContent?: string | null | undefined, contractStartDate?: any | null | undefined, contractEndDate?: any | null | undefined, incomeType?: IncomeTypeEnum | null | undefined, amount?: number | null | undefined, paymentMethod?: PaymentMethodEnum | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, contractorName?: string | null | undefined, contractorAddress?: string | null | undefined, contractorContactAddress?: string | null | undefined, contractorEmail?: string | null | undefined, contractorPhone?: string | null | undefined, contractorIdNumber?: string | null | undefined, contractorTaxClassification?: TaxClassificationEnum | null | undefined, contractorNoInsurance?: boolean | null | undefined, contractorBankCode?: string | null | undefined, contractorBankAccountNumber?: string | null | undefined, contractorBankAccountName?: string | null | undefined, contractorNationality?: string | null | undefined, editable: boolean, uuid?: string | null | undefined, operator?: string | null | undefined, operatorPhone?: string | null | undefined, company: { __typename?: 'Company', id: number, name: string }, idBackFile?: { __typename?: 'FileObjectType', createdAt: any, id: string, mimetype: string, name: string, type?: FileTypeEnum | null | undefined, uri: string } | null | undefined, idFrontFile?: { __typename?: 'FileObjectType', createdAt: any, id: string, mimetype: string, name: string, type?: FileTypeEnum | null | undefined, uri: string } | null | undefined, signatureFile?: { __typename?: 'FileObjectType', createdAt: any, id: string, mimetype: string, name: string, type?: FileTypeEnum | null | undefined, uri: string } | null | undefined, passbookFile?: { __typename?: 'FileObjectType', createdAt: any, id: string, mimetype: string, name: string, type?: FileTypeEnum | null | undefined, uri: string } | null | undefined } };

export type NoopMutationVariables = Exact<{ [key: string]: never; }>;


export type NoopMutation = { __typename?: 'Mutation', noop: number };

export type SetPublicLaborContractSignatureMutationVariables = Exact<{
  signatureFileId: Scalars['String'];
  uuid: Scalars['String'];
}>;


export type SetPublicLaborContractSignatureMutation = { __typename?: 'Mutation', setPublicLaborContractSignature: { __typename?: 'PublicLaborContract', id: number } };

export type SubmitPublicLaborContractMutationVariables = Exact<{
  uuid: Scalars['String'];
  status: Scalars['String'];
}>;


export type SubmitPublicLaborContractMutation = { __typename?: 'Mutation', submitPublicLaborContract: { __typename?: 'PublicLaborContract', id: number, status?: LaborContractStatusEnum | null | undefined } };

export type UpdatePublicLaborContractMutationVariables = Exact<{
  publicLaborContract: PublicLaborContractUpdateDto;
  uuid: Scalars['String'];
}>;


export type UpdatePublicLaborContractMutation = { __typename?: 'Mutation', updatePublicLaborContract: { __typename?: 'PublicLaborContract', amount?: number | null | undefined, assigneeId?: number | null | undefined, contractContent?: string | null | undefined, contractEndDate?: any | null | undefined, contractStartDate?: any | null | undefined, contractorAddress?: string | null | undefined, contractorEmail?: string | null | undefined, contractorIdNumber?: string | null | undefined, contractorTaxClassification?: TaxClassificationEnum | null | undefined, contractorName?: string | null | undefined, contractorPhone?: string | null | undefined, createdAt: any, date?: any | null | undefined, id: number, incomeType?: IncomeTypeEnum | null | undefined, name: string, payDate?: any | null | undefined, paymentMethod?: PaymentMethodEnum | null | undefined, status?: LaborContractStatusEnum | null | undefined, updatedAt: any, signatureFile?: { __typename?: 'FileObjectType', createdAt: any, id: string, mimetype: string, name: string, type?: FileTypeEnum | null | undefined, uri: string } | null | undefined } };

export type CreateLaborContractMutationVariables = Exact<{
  laborContract: CreateLaborContractDto;
}>;


export type CreateLaborContractMutation = { __typename?: 'Mutation', createLaborContract: { __typename?: 'LaborContract', id: number } };

export type GetLaborContractQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetLaborContractQuery = { __typename?: 'Query', laborContract: { __typename?: 'LaborContract', id: number, createdAt: any, updatedAt: any, name: string, status?: LaborContractStatusEnum | null | undefined, date?: any | null | undefined, payDate?: any | null | undefined, contractContent?: string | null | undefined, contractStartDate?: any | null | undefined, contractEndDate?: any | null | undefined, incomeType?: IncomeTypeEnum | null | undefined, amount?: number | null | undefined, paymentMethod?: PaymentMethodEnum | null | undefined, contractorName?: string | null | undefined, contractorAddress?: string | null | undefined, contractorContactAddress?: string | null | undefined, contractorEmail?: string | null | undefined, contractorPhone?: string | null | undefined, contractorIdNumber?: string | null | undefined, contractorTaxClassification?: TaxClassificationEnum | null | undefined, contractorNoInsurance?: boolean | null | undefined, editable: boolean, contractorBankCode?: string | null | undefined, contractorBankAccountNumber?: string | null | undefined, contractorBankAccountName?: string | null | undefined, uuid?: string | null | undefined, contractorNationality?: string | null | undefined, operator?: string | null | undefined, operatorPhone?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, taxPaid: boolean, company: { __typename?: 'Company', id: number, name: string, taxId?: string | null | undefined, contractors: Array<{ __typename?: 'Contractor', id: number, name?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, address?: string | null | undefined, idNumber?: string | null | undefined, taxClassification?: TaxClassificationEnum | null | undefined, contactAddress?: string | null | undefined, bankCode?: string | null | undefined, bankAccountNumber?: string | null | undefined, bankAccountName?: string | null | undefined, nationality?: string | null | undefined, noInsurance?: boolean | null | undefined }> }, idFrontFile?: { __typename?: 'FileObjectType', createdAt: any, id: string, mimetype: string, name: string, type?: FileTypeEnum | null | undefined, uri: string } | null | undefined, idBackFile?: { __typename?: 'FileObjectType', createdAt: any, id: string, mimetype: string, name: string, type?: FileTypeEnum | null | undefined, uri: string } | null | undefined, signatureFile?: { __typename?: 'FileObjectType', createdAt: any, id: string, mimetype: string, name: string, type?: FileTypeEnum | null | undefined, uri: string } | null | undefined, passbookFile?: { __typename?: 'FileObjectType', createdAt: any, id: string, mimetype: string, name: string, type?: FileTypeEnum | null | undefined, uri: string } | null | undefined } };

export type DuplicateLaborContractMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DuplicateLaborContractMutation = { __typename?: 'Mutation', duplicateLaborContract: { __typename?: 'LaborContract', id: number, status?: LaborContractStatusEnum | null | undefined, name: string } };

export type GetLaborContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLaborContractsQuery = { __typename?: 'Query', laborContracts: Array<{ __typename?: 'LaborContract', amount?: number | null | undefined, assigneeId?: number | null | undefined, contractContent?: string | null | undefined, contractEndDate?: any | null | undefined, contractStartDate?: any | null | undefined, contractorAddress?: string | null | undefined, contractorEmail?: string | null | undefined, contractorIdNumber?: string | null | undefined, contractorTaxClassification?: TaxClassificationEnum | null | undefined, contractorName?: string | null | undefined, contractorPhone?: string | null | undefined, contractorNoInsurance?: boolean | null | undefined, createdAt: any, date?: any | null | undefined, id: number, incomeType?: IncomeTypeEnum | null | undefined, name: string, payDate?: any | null | undefined, paymentMethod?: PaymentMethodEnum | null | undefined, status?: LaborContractStatusEnum | null | undefined, updatedAt: any, taxPaid: boolean, company: { __typename?: 'Company', id: number, name: string } }> };

export type RemoveLaborContractMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveLaborContractMutation = { __typename?: 'Mutation', removeLaborContract: number };

export type UpdateLaborContractMutationVariables = Exact<{
  laborContract: UpdateLaborContractDto;
  id: Scalars['Int'];
}>;


export type UpdateLaborContractMutation = { __typename?: 'Mutation', updateLaborContract: { __typename?: 'LaborContract', amount?: number | null | undefined, assigneeId?: number | null | undefined, contractContent?: string | null | undefined, contractEndDate?: any | null | undefined, contractStartDate?: any | null | undefined, contractorAddress?: string | null | undefined, contractorEmail?: string | null | undefined, contractorIdNumber?: string | null | undefined, contractorTaxClassification?: TaxClassificationEnum | null | undefined, contractorName?: string | null | undefined, contractorPhone?: string | null | undefined, createdAt: any, date?: any | null | undefined, id: number, incomeType?: IncomeTypeEnum | null | undefined, name: string, payDate?: any | null | undefined, paymentMethod?: PaymentMethodEnum | null | undefined, status?: LaborContractStatusEnum | null | undefined, updatedAt: any } };

export type CreateLeaveMutationVariables = Exact<{
  leave: LeaveInputType;
}>;


export type CreateLeaveMutation = { __typename?: 'Mutation', createLeave: { __typename?: 'Leave', id: number } };

export type CreateLeaveItemMutationVariables = Exact<{
  leaveItem: LeaveItemInputType;
}>;


export type CreateLeaveItemMutation = { __typename?: 'Mutation', createLeaveItem: { __typename?: 'LeaveItem', id: number } };

export type CreateWorkRecordMutationVariables = Exact<{
  workRecord: WorkRecordInputType;
}>;


export type CreateWorkRecordMutation = { __typename?: 'Mutation', createWorkRecord: { __typename?: 'WorkRecord', id: number } };

export type GetLeavesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeavesQuery = { __typename?: 'Query', leaves: Array<{ __typename?: 'Leave', id: number, title?: string | null | undefined, limit?: string | null | undefined, salaryStandard?: SalaryStandardEnum | null | undefined, description?: string | null | undefined, disabled?: boolean | null | undefined, company?: { __typename?: 'Company', id: number, name: string } | null | undefined }> };

export type GetLeaveItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeaveItemsQuery = { __typename?: 'Query', leaveItems: Array<{ __typename?: 'LeaveItem', id: number, salaryMultiple?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, restHours?: number | null | undefined, description?: string | null | undefined, leave: { __typename?: 'Leave', id: number, title?: string | null | undefined }, employee: { __typename?: 'Employee', id: number, name?: string | null | undefined, code?: string | null | undefined, company?: { __typename?: 'Company', id: number, name: string } | null | undefined } }> };

export type GetWorkRecordsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkRecordsQuery = { __typename?: 'Query', workRecords: Array<{ __typename?: 'WorkRecord', id: number, dayType?: DayTypeEnum | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, restHours?: number | null | undefined, description?: string | null | undefined, employee?: { __typename?: 'Employee', id: number, name?: string | null | undefined, code?: string | null | undefined, company?: { __typename?: 'Company', id: number, name: string } | null | undefined } | null | undefined }> };

export type RemoveLeaveItemMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveLeaveItemMutation = { __typename?: 'Mutation', removeLeaveItem: number };

export type RemoveWorkRecordMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveWorkRecordMutation = { __typename?: 'Mutation', removeWorkRecord: number };

export type UpdateLeaveMutationVariables = Exact<{
  leave: LeaveInputType;
  id: Scalars['Int'];
}>;


export type UpdateLeaveMutation = { __typename?: 'Mutation', updateLeave: { __typename?: 'Leave', id: number } };

export type UpdateLeaveItemMutationVariables = Exact<{
  leaveItem: LeaveItemInputType;
  id: Scalars['Int'];
}>;


export type UpdateLeaveItemMutation = { __typename?: 'Mutation', updateLeaveItem: { __typename?: 'LeaveItem', id: number } };

export type UpdateWorkRecordMutationVariables = Exact<{
  workRecord: WorkRecordInputType;
  id: Scalars['Int'];
}>;


export type UpdateWorkRecordMutation = { __typename?: 'Mutation', updateWorkRecord: { __typename?: 'WorkRecord', id: number } };

export type CreateSalaryExtendMutationVariables = Exact<{
  salaryExtendDto: SalaryExtendInputType;
}>;


export type CreateSalaryExtendMutation = { __typename?: 'Mutation', createSalaryExtend: { __typename?: 'SalaryExtend', id: number } };

export type CreateSalaryGroupMutationVariables = Exact<{
  salaryGroup: SalaryGroupInputType;
}>;


export type CreateSalaryGroupMutation = { __typename?: 'Mutation', createSalaryGroup: { __typename?: 'SalaryGroup', id: number } };

export type GetSalaryGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalaryGroupsQuery = { __typename?: 'Query', salaryGroups: Array<{ __typename?: 'SalaryGroup', id: number, yearMonth?: string | null | undefined, title?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, payDate?: any | null | undefined, company?: { __typename?: 'Company', id: number, name: string } | null | undefined, salaries?: Array<{ __typename?: 'Salary', id: number, employee?: { __typename?: 'Employee', id: number, name?: string | null | undefined, code?: string | null | undefined } | null | undefined, salaryItems?: Array<{ __typename?: 'SalaryItem', id: number, title?: string | null | undefined, amount?: number | null | undefined, type?: SalaryItemTypeEnum | null | undefined }> | null | undefined }> | null | undefined }> };

export type GetSalariesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalariesQuery = { __typename?: 'Query', salaries: Array<{ __typename?: 'Salary', id: number, updatedAt: any, salaryGroup?: { __typename?: 'SalaryGroup', yearMonth?: string | null | undefined, title?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined } | null | undefined, employee?: { __typename?: 'Employee', code?: string | null | undefined, name?: string | null | undefined, company?: { __typename?: 'Company', id: number, name: string } | null | undefined } | null | undefined, salaryItems?: Array<{ __typename?: 'SalaryItem', title?: string | null | undefined, amount?: number | null | undefined, type?: SalaryItemTypeEnum | null | undefined }> | null | undefined }> };

export type GetSalaryExtendsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalaryExtendsQuery = { __typename?: 'Query', salaryExtends: Array<{ __typename?: 'SalaryExtend', id: number, yearMonth?: string | null | undefined, subject?: string | null | undefined, amount?: number | null | undefined, description?: string | null | undefined, type?: SalaryItemTypeEnum | null | undefined, employee?: { __typename?: 'Employee', id: number, name?: string | null | undefined, code?: string | null | undefined, company?: { __typename?: 'Company', id: number, name: string } | null | undefined } | null | undefined }> };

export type CalculateSalariesQueryVariables = Exact<{
  yearMonth: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  companyId: Scalars['Int'];
}>;


export type CalculateSalariesQuery = { __typename?: 'Query', calculateSalaries: Array<{ __typename?: 'Salary', employee?: { __typename?: 'Employee', id: number, name?: string | null | undefined, code?: string | null | undefined, arrivalDate?: any | null | undefined, leaveDate?: any | null | undefined, type?: WorkTypeEnum | null | undefined } | null | undefined, salaryItems?: Array<{ __typename?: 'SalaryItem', title?: string | null | undefined, amount?: number | null | undefined, type?: SalaryItemTypeEnum | null | undefined }> | null | undefined }> };

export type RemoveSalaryExtendMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveSalaryExtendMutation = { __typename?: 'Mutation', removeSalaryExtend: number };

export type RemoveSalaryGroupMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveSalaryGroupMutation = { __typename?: 'Mutation', removeSalaryGroup: number };

export type SendSalariesMutationVariables = Exact<{
  subject: Scalars['String'];
  body: Scalars['String'];
  salaryIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type SendSalariesMutation = { __typename?: 'Mutation', sendSalaries: number };

export type UpdateSalaryExtendMutationVariables = Exact<{
  salaryExtendDto: SalaryExtendInputType;
  id: Scalars['Int'];
}>;


export type UpdateSalaryExtendMutation = { __typename?: 'Mutation', updateSalaryExtend: { __typename?: 'SalaryExtend', id: number } };

export type CreateUserMutationVariables = Exact<{
  user: CreateUserDto;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: number } };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, name?: string | null | undefined, email: string, roles: Array<RoleEnum>, picture?: string | null | undefined, disabled: boolean, authorizations: Array<Authorization>, companies: Array<{ __typename?: 'Company', id: number, name: string }> }> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: number, name?: string | null | undefined, email: string, roles: Array<RoleEnum>, picture?: string | null | undefined, authorizations: Array<Authorization>, companies: Array<{ __typename?: 'Company', id: number, name: string, contractors: Array<{ __typename?: 'Contractor', id: number, name?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, address?: string | null | undefined, idNumber?: string | null | undefined, taxClassification?: TaxClassificationEnum | null | undefined, contactAddress?: string | null | undefined, bankCode?: string | null | undefined, bankAccountNumber?: string | null | undefined, bankAccountName?: string | null | undefined, nationality?: string | null | undefined, noInsurance?: boolean | null | undefined }>, reports: Array<{ __typename?: 'FileObjectType', id: string, name: string, uri: string }>, companyAuthorizations?: Array<{ __typename?: 'CompanyAuthorization', id: number, authorization: Authorization, startDate?: any | null | undefined, endDate?: any | null | undefined, remindDate?: any | null | undefined, enabled?: boolean | null | undefined }> | null | undefined }> } };

export type RemoveUserMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser: number };

export type UpdateUserMutationVariables = Exact<{
  user: UpdateUserDto;
  id: Scalars['Int'];
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number, name?: string | null | undefined } };


export const CreateCompanyDocument = gql`
    mutation createCompany($company: CompanyInputType!) {
  createCompany(company: $company) {
    id
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      company: // value for 'company'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const GetCompaniesDocument = gql`
    query getCompanies {
  companies {
    createdAt
    enabled
    id
    name
    taxId
    updatedAt
    companyAuthorizations {
      authorization
      startDate
      endDate
      remindDate
      enabled
    }
  }
}
    `;

/**
 * __useGetCompaniesQuery__
 *
 * To run a query within a React component, call `useGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
      }
export function useGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
        }
export type GetCompaniesQueryHookResult = ReturnType<typeof useGetCompaniesQuery>;
export type GetCompaniesLazyQueryHookResult = ReturnType<typeof useGetCompaniesLazyQuery>;
export type GetCompaniesQueryResult = Apollo.QueryResult<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const RemoveCompanyDocument = gql`
    mutation removeCompany($id: Int!) {
  removeCompany(id: $id)
}
    `;
export type RemoveCompanyMutationFn = Apollo.MutationFunction<RemoveCompanyMutation, RemoveCompanyMutationVariables>;

/**
 * __useRemoveCompanyMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyMutation, { data, loading, error }] = useRemoveCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCompanyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyMutation, RemoveCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyMutation, RemoveCompanyMutationVariables>(RemoveCompanyDocument, options);
      }
export type RemoveCompanyMutationHookResult = ReturnType<typeof useRemoveCompanyMutation>;
export type RemoveCompanyMutationResult = Apollo.MutationResult<RemoveCompanyMutation>;
export type RemoveCompanyMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyMutation, RemoveCompanyMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($id: Int!, $company: CompanyInputType!) {
  updateCompany(id: $id, company: $company) {
    id
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      company: // value for 'company'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const GetConfigDocument = gql`
    query getConfig($key: String!) {
  config(key: $key) {
    id
    key
    value
  }
}
    `;

/**
 * __useGetConfigQuery__
 *
 * To run a query within a React component, call `useGetConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetConfigQuery(baseOptions: Apollo.QueryHookOptions<GetConfigQuery, GetConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigQuery, GetConfigQueryVariables>(GetConfigDocument, options);
      }
export function useGetConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigQuery, GetConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigQuery, GetConfigQueryVariables>(GetConfigDocument, options);
        }
export type GetConfigQueryHookResult = ReturnType<typeof useGetConfigQuery>;
export type GetConfigLazyQueryHookResult = ReturnType<typeof useGetConfigLazyQuery>;
export type GetConfigQueryResult = Apollo.QueryResult<GetConfigQuery, GetConfigQueryVariables>;
export const UpsertConfigDocument = gql`
    mutation upsertConfig($key: String!, $config: ConfigInputType!) {
  upsertConfig(key: $key, config: $config) {
    id
    key
    value
  }
}
    `;
export type UpsertConfigMutationFn = Apollo.MutationFunction<UpsertConfigMutation, UpsertConfigMutationVariables>;

/**
 * __useUpsertConfigMutation__
 *
 * To run a mutation, you first call `useUpsertConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertConfigMutation, { data, loading, error }] = useUpsertConfigMutation({
 *   variables: {
 *      key: // value for 'key'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useUpsertConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpsertConfigMutation, UpsertConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertConfigMutation, UpsertConfigMutationVariables>(UpsertConfigDocument, options);
      }
export type UpsertConfigMutationHookResult = ReturnType<typeof useUpsertConfigMutation>;
export type UpsertConfigMutationResult = Apollo.MutationResult<UpsertConfigMutation>;
export type UpsertConfigMutationOptions = Apollo.BaseMutationOptions<UpsertConfigMutation, UpsertConfigMutationVariables>;
export const CreateContractorDocument = gql`
    mutation createContractor($contractor: ContractorInputType!) {
  createContractor(contractor: $contractor) {
    id
    name
    address
    email
    phone
    idNumber
  }
}
    `;
export type CreateContractorMutationFn = Apollo.MutationFunction<CreateContractorMutation, CreateContractorMutationVariables>;

/**
 * __useCreateContractorMutation__
 *
 * To run a mutation, you first call `useCreateContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractorMutation, { data, loading, error }] = useCreateContractorMutation({
 *   variables: {
 *      contractor: // value for 'contractor'
 *   },
 * });
 */
export function useCreateContractorMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractorMutation, CreateContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractorMutation, CreateContractorMutationVariables>(CreateContractorDocument, options);
      }
export type CreateContractorMutationHookResult = ReturnType<typeof useCreateContractorMutation>;
export type CreateContractorMutationResult = Apollo.MutationResult<CreateContractorMutation>;
export type CreateContractorMutationOptions = Apollo.BaseMutationOptions<CreateContractorMutation, CreateContractorMutationVariables>;
export const GetContractorsDocument = gql`
    query getContractors {
  contractors {
    id
    name
    address
    contactAddress
    nationality
    email
    phone
    idNumber
    taxClassification
    company {
      id
      name
    }
    noInsurance
    idBackFile {
      id
      uri
    }
    idFrontFile {
      id
      uri
    }
    passbookFile {
      id
      uri
    }
    bankCode
    bankAccountNumber
    bankAccountName
  }
}
    `;

/**
 * __useGetContractorsQuery__
 *
 * To run a query within a React component, call `useGetContractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractorsQuery(baseOptions?: Apollo.QueryHookOptions<GetContractorsQuery, GetContractorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractorsQuery, GetContractorsQueryVariables>(GetContractorsDocument, options);
      }
export function useGetContractorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractorsQuery, GetContractorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractorsQuery, GetContractorsQueryVariables>(GetContractorsDocument, options);
        }
export type GetContractorsQueryHookResult = ReturnType<typeof useGetContractorsQuery>;
export type GetContractorsLazyQueryHookResult = ReturnType<typeof useGetContractorsLazyQuery>;
export type GetContractorsQueryResult = Apollo.QueryResult<GetContractorsQuery, GetContractorsQueryVariables>;
export const RemoveContractorDocument = gql`
    mutation removeContractor($id: Int!) {
  removeContractor(id: $id)
}
    `;
export type RemoveContractorMutationFn = Apollo.MutationFunction<RemoveContractorMutation, RemoveContractorMutationVariables>;

/**
 * __useRemoveContractorMutation__
 *
 * To run a mutation, you first call `useRemoveContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContractorMutation, { data, loading, error }] = useRemoveContractorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveContractorMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContractorMutation, RemoveContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContractorMutation, RemoveContractorMutationVariables>(RemoveContractorDocument, options);
      }
export type RemoveContractorMutationHookResult = ReturnType<typeof useRemoveContractorMutation>;
export type RemoveContractorMutationResult = Apollo.MutationResult<RemoveContractorMutation>;
export type RemoveContractorMutationOptions = Apollo.BaseMutationOptions<RemoveContractorMutation, RemoveContractorMutationVariables>;
export const UpdateContractorDocument = gql`
    mutation updateContractor($contractor: ContractorInputType!, $id: Int!) {
  updateContractor(contractor: $contractor, id: $id) {
    id
    name
    address
    email
    phone
    idNumber
    taxClassification
  }
}
    `;
export type UpdateContractorMutationFn = Apollo.MutationFunction<UpdateContractorMutation, UpdateContractorMutationVariables>;

/**
 * __useUpdateContractorMutation__
 *
 * To run a mutation, you first call `useUpdateContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractorMutation, { data, loading, error }] = useUpdateContractorMutation({
 *   variables: {
 *      contractor: // value for 'contractor'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateContractorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractorMutation, UpdateContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractorMutation, UpdateContractorMutationVariables>(UpdateContractorDocument, options);
      }
export type UpdateContractorMutationHookResult = ReturnType<typeof useUpdateContractorMutation>;
export type UpdateContractorMutationResult = Apollo.MutationResult<UpdateContractorMutation>;
export type UpdateContractorMutationOptions = Apollo.BaseMutationOptions<UpdateContractorMutation, UpdateContractorMutationVariables>;
export const CreateEmployeeDocument = gql`
    mutation createEmployee($employee: EmployeeInputType!) {
  createEmployee(employee: $employee) {
    id
  }
}
    `;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      employee: // value for 'employee'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const GetEmployeeDocument = gql`
    query getEmployee($id: Int!) {
  employee(id: $id) {
    id
    createdAt
    updatedAt
    code
    name
    gender
    nationality
    birthday
    idNumber
    state
    arrivalDate
    leaveDate
    email
    address
    phone
    bankCode
    accountNumber
    prepaid
    identity
    type
    salaryItems {
      title
      amount
      type
    }
    pickup
    description
    dependents {
      name
      relation
      idNumber
      gender
      nationality
      birthday
    }
    company {
      id
      name
    }
    laborInsuranceAmount
    healthInsuranceAmount
    pensionAmount
    disabled
  }
}
    `;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
      }
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
        }
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetEmployeesDocument = gql`
    query getEmployees {
  employees {
    id
    createdAt
    updatedAt
    code
    name
    gender
    nationality
    birthday
    idNumber
    state
    arrivalDate
    leaveDate
    email
    address
    phone
    bankCode
    accountNumber
    identity
    type
    salaryItems {
      title
      amount
      type
    }
    pickup
    description
    dependents {
      name
      relation
      idNumber
      gender
      nationality
      birthday
    }
    company {
      id
      name
    }
    laborInsuranceAmount
    healthInsuranceAmount
    pensionAmount
    disabled
  }
}
    `;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
      }
export function useGetEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const UpdateEmployeeDocument = gql`
    mutation updateEmployee($employee: EmployeeInputType!, $id: Int!) {
  updateEmployee(employee: $employee, id: $id) {
    id
  }
}
    `;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      employee: // value for 'employee'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const GetPublicLaborContractDocument = gql`
    query getPublicLaborContract($uuid: String!) {
  publicLaborContract(uuid: $uuid) {
    id
    createdAt
    updatedAt
    name
    status
    date
    payDate
    contractContent
    contractStartDate
    contractEndDate
    incomeType
    amount
    paymentMethod
    startDate
    endDate
    contractorName
    contractorAddress
    contractorContactAddress
    contractorEmail
    contractorPhone
    contractorIdNumber
    contractorTaxClassification
    contractorNoInsurance
    contractorBankCode
    contractorBankAccountNumber
    contractorBankAccountName
    contractorNationality
    company {
      id
      name
    }
    editable
    idBackFile {
      createdAt
      id
      mimetype
      name
      type
      uri
    }
    idFrontFile {
      createdAt
      id
      mimetype
      name
      type
      uri
    }
    idBackFile {
      createdAt
      id
      mimetype
      name
      type
      uri
    }
    signatureFile {
      createdAt
      id
      mimetype
      name
      type
      uri
    }
    passbookFile {
      createdAt
      id
      mimetype
      name
      type
      uri
    }
    uuid
    operator
    operatorPhone
  }
}
    `;

/**
 * __useGetPublicLaborContractQuery__
 *
 * To run a query within a React component, call `useGetPublicLaborContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicLaborContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicLaborContractQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetPublicLaborContractQuery(baseOptions: Apollo.QueryHookOptions<GetPublicLaborContractQuery, GetPublicLaborContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicLaborContractQuery, GetPublicLaborContractQueryVariables>(GetPublicLaborContractDocument, options);
      }
export function useGetPublicLaborContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicLaborContractQuery, GetPublicLaborContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicLaborContractQuery, GetPublicLaborContractQueryVariables>(GetPublicLaborContractDocument, options);
        }
export type GetPublicLaborContractQueryHookResult = ReturnType<typeof useGetPublicLaborContractQuery>;
export type GetPublicLaborContractLazyQueryHookResult = ReturnType<typeof useGetPublicLaborContractLazyQuery>;
export type GetPublicLaborContractQueryResult = Apollo.QueryResult<GetPublicLaborContractQuery, GetPublicLaborContractQueryVariables>;
export const NoopDocument = gql`
    mutation Noop {
  noop
}
    `;
export type NoopMutationFn = Apollo.MutationFunction<NoopMutation, NoopMutationVariables>;

/**
 * __useNoopMutation__
 *
 * To run a mutation, you first call `useNoopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noopMutation, { data, loading, error }] = useNoopMutation({
 *   variables: {
 *   },
 * });
 */
export function useNoopMutation(baseOptions?: Apollo.MutationHookOptions<NoopMutation, NoopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoopMutation, NoopMutationVariables>(NoopDocument, options);
      }
export type NoopMutationHookResult = ReturnType<typeof useNoopMutation>;
export type NoopMutationResult = Apollo.MutationResult<NoopMutation>;
export type NoopMutationOptions = Apollo.BaseMutationOptions<NoopMutation, NoopMutationVariables>;
export const SetPublicLaborContractSignatureDocument = gql`
    mutation setPublicLaborContractSignature($signatureFileId: String!, $uuid: String!) {
  setPublicLaborContractSignature(signatureFileId: $signatureFileId, uuid: $uuid) {
    id
  }
}
    `;
export type SetPublicLaborContractSignatureMutationFn = Apollo.MutationFunction<SetPublicLaborContractSignatureMutation, SetPublicLaborContractSignatureMutationVariables>;

/**
 * __useSetPublicLaborContractSignatureMutation__
 *
 * To run a mutation, you first call `useSetPublicLaborContractSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPublicLaborContractSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPublicLaborContractSignatureMutation, { data, loading, error }] = useSetPublicLaborContractSignatureMutation({
 *   variables: {
 *      signatureFileId: // value for 'signatureFileId'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSetPublicLaborContractSignatureMutation(baseOptions?: Apollo.MutationHookOptions<SetPublicLaborContractSignatureMutation, SetPublicLaborContractSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPublicLaborContractSignatureMutation, SetPublicLaborContractSignatureMutationVariables>(SetPublicLaborContractSignatureDocument, options);
      }
export type SetPublicLaborContractSignatureMutationHookResult = ReturnType<typeof useSetPublicLaborContractSignatureMutation>;
export type SetPublicLaborContractSignatureMutationResult = Apollo.MutationResult<SetPublicLaborContractSignatureMutation>;
export type SetPublicLaborContractSignatureMutationOptions = Apollo.BaseMutationOptions<SetPublicLaborContractSignatureMutation, SetPublicLaborContractSignatureMutationVariables>;
export const SubmitPublicLaborContractDocument = gql`
    mutation submitPublicLaborContract($uuid: String!, $status: String!) {
  submitPublicLaborContract(uuid: $uuid, status: $status) {
    id
    status
  }
}
    `;
export type SubmitPublicLaborContractMutationFn = Apollo.MutationFunction<SubmitPublicLaborContractMutation, SubmitPublicLaborContractMutationVariables>;

/**
 * __useSubmitPublicLaborContractMutation__
 *
 * To run a mutation, you first call `useSubmitPublicLaborContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPublicLaborContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPublicLaborContractMutation, { data, loading, error }] = useSubmitPublicLaborContractMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSubmitPublicLaborContractMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPublicLaborContractMutation, SubmitPublicLaborContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPublicLaborContractMutation, SubmitPublicLaborContractMutationVariables>(SubmitPublicLaborContractDocument, options);
      }
export type SubmitPublicLaborContractMutationHookResult = ReturnType<typeof useSubmitPublicLaborContractMutation>;
export type SubmitPublicLaborContractMutationResult = Apollo.MutationResult<SubmitPublicLaborContractMutation>;
export type SubmitPublicLaborContractMutationOptions = Apollo.BaseMutationOptions<SubmitPublicLaborContractMutation, SubmitPublicLaborContractMutationVariables>;
export const UpdatePublicLaborContractDocument = gql`
    mutation updatePublicLaborContract($publicLaborContract: PublicLaborContractUpdateDto!, $uuid: String!) {
  updatePublicLaborContract(
    publicLaborContract: $publicLaborContract
    uuid: $uuid
  ) {
    amount
    assigneeId
    contractContent
    contractEndDate
    contractStartDate
    contractorAddress
    contractorEmail
    contractorIdNumber
    contractorTaxClassification
    contractorName
    contractorPhone
    createdAt
    date
    id
    incomeType
    name
    payDate
    paymentMethod
    status
    updatedAt
    signatureFile {
      createdAt
      id
      mimetype
      name
      type
      uri
    }
  }
}
    `;
export type UpdatePublicLaborContractMutationFn = Apollo.MutationFunction<UpdatePublicLaborContractMutation, UpdatePublicLaborContractMutationVariables>;

/**
 * __useUpdatePublicLaborContractMutation__
 *
 * To run a mutation, you first call `useUpdatePublicLaborContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublicLaborContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublicLaborContractMutation, { data, loading, error }] = useUpdatePublicLaborContractMutation({
 *   variables: {
 *      publicLaborContract: // value for 'publicLaborContract'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useUpdatePublicLaborContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePublicLaborContractMutation, UpdatePublicLaborContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePublicLaborContractMutation, UpdatePublicLaborContractMutationVariables>(UpdatePublicLaborContractDocument, options);
      }
export type UpdatePublicLaborContractMutationHookResult = ReturnType<typeof useUpdatePublicLaborContractMutation>;
export type UpdatePublicLaborContractMutationResult = Apollo.MutationResult<UpdatePublicLaborContractMutation>;
export type UpdatePublicLaborContractMutationOptions = Apollo.BaseMutationOptions<UpdatePublicLaborContractMutation, UpdatePublicLaborContractMutationVariables>;
export const CreateLaborContractDocument = gql`
    mutation createLaborContract($laborContract: CreateLaborContractDto!) {
  createLaborContract(laborContract: $laborContract) {
    id
  }
}
    `;
export type CreateLaborContractMutationFn = Apollo.MutationFunction<CreateLaborContractMutation, CreateLaborContractMutationVariables>;

/**
 * __useCreateLaborContractMutation__
 *
 * To run a mutation, you first call `useCreateLaborContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLaborContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLaborContractMutation, { data, loading, error }] = useCreateLaborContractMutation({
 *   variables: {
 *      laborContract: // value for 'laborContract'
 *   },
 * });
 */
export function useCreateLaborContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateLaborContractMutation, CreateLaborContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLaborContractMutation, CreateLaborContractMutationVariables>(CreateLaborContractDocument, options);
      }
export type CreateLaborContractMutationHookResult = ReturnType<typeof useCreateLaborContractMutation>;
export type CreateLaborContractMutationResult = Apollo.MutationResult<CreateLaborContractMutation>;
export type CreateLaborContractMutationOptions = Apollo.BaseMutationOptions<CreateLaborContractMutation, CreateLaborContractMutationVariables>;
export const GetLaborContractDocument = gql`
    query getLaborContract($id: Int!) {
  laborContract(id: $id) {
    id
    createdAt
    updatedAt
    name
    status
    date
    payDate
    contractContent
    contractStartDate
    contractEndDate
    incomeType
    amount
    paymentMethod
    contractorName
    contractorAddress
    contractorContactAddress
    contractorEmail
    contractorPhone
    contractorIdNumber
    contractorTaxClassification
    contractorNoInsurance
    company {
      id
      name
      contractors {
        id
        name
        phone
        email
        address
        idNumber
        taxClassification
        contactAddress
        bankCode
        bankAccountNumber
        bankAccountName
        nationality
        noInsurance
      }
      taxId
    }
    editable
    idFrontFile {
      createdAt
      id
      mimetype
      name
      type
      uri
    }
    idBackFile {
      createdAt
      id
      mimetype
      name
      type
      uri
    }
    signatureFile {
      createdAt
      id
      mimetype
      name
      type
      uri
    }
    passbookFile {
      createdAt
      id
      mimetype
      name
      type
      uri
    }
    contractorBankCode
    contractorBankAccountNumber
    contractorBankAccountName
    uuid
    contractorNationality
    operator
    operatorPhone
    startDate
    endDate
    taxPaid
  }
}
    `;

/**
 * __useGetLaborContractQuery__
 *
 * To run a query within a React component, call `useGetLaborContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaborContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaborContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLaborContractQuery(baseOptions: Apollo.QueryHookOptions<GetLaborContractQuery, GetLaborContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaborContractQuery, GetLaborContractQueryVariables>(GetLaborContractDocument, options);
      }
export function useGetLaborContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaborContractQuery, GetLaborContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaborContractQuery, GetLaborContractQueryVariables>(GetLaborContractDocument, options);
        }
export type GetLaborContractQueryHookResult = ReturnType<typeof useGetLaborContractQuery>;
export type GetLaborContractLazyQueryHookResult = ReturnType<typeof useGetLaborContractLazyQuery>;
export type GetLaborContractQueryResult = Apollo.QueryResult<GetLaborContractQuery, GetLaborContractQueryVariables>;
export const DuplicateLaborContractDocument = gql`
    mutation duplicateLaborContract($id: Int!) {
  duplicateLaborContract(id: $id) {
    id
    status
    name
  }
}
    `;
export type DuplicateLaborContractMutationFn = Apollo.MutationFunction<DuplicateLaborContractMutation, DuplicateLaborContractMutationVariables>;

/**
 * __useDuplicateLaborContractMutation__
 *
 * To run a mutation, you first call `useDuplicateLaborContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateLaborContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateLaborContractMutation, { data, loading, error }] = useDuplicateLaborContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateLaborContractMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateLaborContractMutation, DuplicateLaborContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateLaborContractMutation, DuplicateLaborContractMutationVariables>(DuplicateLaborContractDocument, options);
      }
export type DuplicateLaborContractMutationHookResult = ReturnType<typeof useDuplicateLaborContractMutation>;
export type DuplicateLaborContractMutationResult = Apollo.MutationResult<DuplicateLaborContractMutation>;
export type DuplicateLaborContractMutationOptions = Apollo.BaseMutationOptions<DuplicateLaborContractMutation, DuplicateLaborContractMutationVariables>;
export const GetLaborContractsDocument = gql`
    query getLaborContracts {
  laborContracts {
    amount
    assigneeId
    contractContent
    contractEndDate
    contractStartDate
    contractorAddress
    contractorEmail
    contractorIdNumber
    contractorTaxClassification
    contractorName
    contractorPhone
    contractorNoInsurance
    createdAt
    date
    id
    incomeType
    name
    payDate
    paymentMethod
    status
    updatedAt
    company {
      id
      name
    }
    taxPaid
  }
}
    `;

/**
 * __useGetLaborContractsQuery__
 *
 * To run a query within a React component, call `useGetLaborContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaborContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaborContractsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLaborContractsQuery(baseOptions?: Apollo.QueryHookOptions<GetLaborContractsQuery, GetLaborContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaborContractsQuery, GetLaborContractsQueryVariables>(GetLaborContractsDocument, options);
      }
export function useGetLaborContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaborContractsQuery, GetLaborContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaborContractsQuery, GetLaborContractsQueryVariables>(GetLaborContractsDocument, options);
        }
export type GetLaborContractsQueryHookResult = ReturnType<typeof useGetLaborContractsQuery>;
export type GetLaborContractsLazyQueryHookResult = ReturnType<typeof useGetLaborContractsLazyQuery>;
export type GetLaborContractsQueryResult = Apollo.QueryResult<GetLaborContractsQuery, GetLaborContractsQueryVariables>;
export const RemoveLaborContractDocument = gql`
    mutation removeLaborContract($id: Int!) {
  removeLaborContract(id: $id)
}
    `;
export type RemoveLaborContractMutationFn = Apollo.MutationFunction<RemoveLaborContractMutation, RemoveLaborContractMutationVariables>;

/**
 * __useRemoveLaborContractMutation__
 *
 * To run a mutation, you first call `useRemoveLaborContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLaborContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLaborContractMutation, { data, loading, error }] = useRemoveLaborContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveLaborContractMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLaborContractMutation, RemoveLaborContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLaborContractMutation, RemoveLaborContractMutationVariables>(RemoveLaborContractDocument, options);
      }
export type RemoveLaborContractMutationHookResult = ReturnType<typeof useRemoveLaborContractMutation>;
export type RemoveLaborContractMutationResult = Apollo.MutationResult<RemoveLaborContractMutation>;
export type RemoveLaborContractMutationOptions = Apollo.BaseMutationOptions<RemoveLaborContractMutation, RemoveLaborContractMutationVariables>;
export const UpdateLaborContractDocument = gql`
    mutation updateLaborContract($laborContract: UpdateLaborContractDto!, $id: Int!) {
  updateLaborContract(laborContract: $laborContract, id: $id) {
    amount
    assigneeId
    contractContent
    contractEndDate
    contractStartDate
    contractorAddress
    contractorEmail
    contractorIdNumber
    contractorTaxClassification
    contractorName
    contractorPhone
    createdAt
    date
    id
    incomeType
    name
    payDate
    paymentMethod
    status
    updatedAt
  }
}
    `;
export type UpdateLaborContractMutationFn = Apollo.MutationFunction<UpdateLaborContractMutation, UpdateLaborContractMutationVariables>;

/**
 * __useUpdateLaborContractMutation__
 *
 * To run a mutation, you first call `useUpdateLaborContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaborContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaborContractMutation, { data, loading, error }] = useUpdateLaborContractMutation({
 *   variables: {
 *      laborContract: // value for 'laborContract'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateLaborContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLaborContractMutation, UpdateLaborContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLaborContractMutation, UpdateLaborContractMutationVariables>(UpdateLaborContractDocument, options);
      }
export type UpdateLaborContractMutationHookResult = ReturnType<typeof useUpdateLaborContractMutation>;
export type UpdateLaborContractMutationResult = Apollo.MutationResult<UpdateLaborContractMutation>;
export type UpdateLaborContractMutationOptions = Apollo.BaseMutationOptions<UpdateLaborContractMutation, UpdateLaborContractMutationVariables>;
export const CreateLeaveDocument = gql`
    mutation createLeave($leave: LeaveInputType!) {
  createLeave(leave: $leave) {
    id
  }
}
    `;
export type CreateLeaveMutationFn = Apollo.MutationFunction<CreateLeaveMutation, CreateLeaveMutationVariables>;

/**
 * __useCreateLeaveMutation__
 *
 * To run a mutation, you first call `useCreateLeaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeaveMutation, { data, loading, error }] = useCreateLeaveMutation({
 *   variables: {
 *      leave: // value for 'leave'
 *   },
 * });
 */
export function useCreateLeaveMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeaveMutation, CreateLeaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeaveMutation, CreateLeaveMutationVariables>(CreateLeaveDocument, options);
      }
export type CreateLeaveMutationHookResult = ReturnType<typeof useCreateLeaveMutation>;
export type CreateLeaveMutationResult = Apollo.MutationResult<CreateLeaveMutation>;
export type CreateLeaveMutationOptions = Apollo.BaseMutationOptions<CreateLeaveMutation, CreateLeaveMutationVariables>;
export const CreateLeaveItemDocument = gql`
    mutation createLeaveItem($leaveItem: LeaveItemInputType!) {
  createLeaveItem(leaveItem: $leaveItem) {
    id
  }
}
    `;
export type CreateLeaveItemMutationFn = Apollo.MutationFunction<CreateLeaveItemMutation, CreateLeaveItemMutationVariables>;

/**
 * __useCreateLeaveItemMutation__
 *
 * To run a mutation, you first call `useCreateLeaveItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeaveItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeaveItemMutation, { data, loading, error }] = useCreateLeaveItemMutation({
 *   variables: {
 *      leaveItem: // value for 'leaveItem'
 *   },
 * });
 */
export function useCreateLeaveItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeaveItemMutation, CreateLeaveItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeaveItemMutation, CreateLeaveItemMutationVariables>(CreateLeaveItemDocument, options);
      }
export type CreateLeaveItemMutationHookResult = ReturnType<typeof useCreateLeaveItemMutation>;
export type CreateLeaveItemMutationResult = Apollo.MutationResult<CreateLeaveItemMutation>;
export type CreateLeaveItemMutationOptions = Apollo.BaseMutationOptions<CreateLeaveItemMutation, CreateLeaveItemMutationVariables>;
export const CreateWorkRecordDocument = gql`
    mutation createWorkRecord($workRecord: WorkRecordInputType!) {
  createWorkRecord(workRecord: $workRecord) {
    id
  }
}
    `;
export type CreateWorkRecordMutationFn = Apollo.MutationFunction<CreateWorkRecordMutation, CreateWorkRecordMutationVariables>;

/**
 * __useCreateWorkRecordMutation__
 *
 * To run a mutation, you first call `useCreateWorkRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkRecordMutation, { data, loading, error }] = useCreateWorkRecordMutation({
 *   variables: {
 *      workRecord: // value for 'workRecord'
 *   },
 * });
 */
export function useCreateWorkRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkRecordMutation, CreateWorkRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkRecordMutation, CreateWorkRecordMutationVariables>(CreateWorkRecordDocument, options);
      }
export type CreateWorkRecordMutationHookResult = ReturnType<typeof useCreateWorkRecordMutation>;
export type CreateWorkRecordMutationResult = Apollo.MutationResult<CreateWorkRecordMutation>;
export type CreateWorkRecordMutationOptions = Apollo.BaseMutationOptions<CreateWorkRecordMutation, CreateWorkRecordMutationVariables>;
export const GetLeavesDocument = gql`
    query getLeaves {
  leaves {
    id
    title
    limit
    salaryStandard
    description
    company {
      id
      name
    }
    disabled
  }
}
    `;

/**
 * __useGetLeavesQuery__
 *
 * To run a query within a React component, call `useGetLeavesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeavesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeavesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeavesQuery(baseOptions?: Apollo.QueryHookOptions<GetLeavesQuery, GetLeavesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeavesQuery, GetLeavesQueryVariables>(GetLeavesDocument, options);
      }
export function useGetLeavesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeavesQuery, GetLeavesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeavesQuery, GetLeavesQueryVariables>(GetLeavesDocument, options);
        }
export type GetLeavesQueryHookResult = ReturnType<typeof useGetLeavesQuery>;
export type GetLeavesLazyQueryHookResult = ReturnType<typeof useGetLeavesLazyQuery>;
export type GetLeavesQueryResult = Apollo.QueryResult<GetLeavesQuery, GetLeavesQueryVariables>;
export const GetLeaveItemsDocument = gql`
    query getLeaveItems {
  leaveItems {
    id
    leave {
      id
      title
    }
    employee {
      id
      name
      code
      company {
        id
        name
      }
    }
    salaryMultiple
    startTime
    endTime
    restHours
    description
  }
}
    `;

/**
 * __useGetLeaveItemsQuery__
 *
 * To run a query within a React component, call `useGetLeaveItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaveItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaveItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeaveItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetLeaveItemsQuery, GetLeaveItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaveItemsQuery, GetLeaveItemsQueryVariables>(GetLeaveItemsDocument, options);
      }
export function useGetLeaveItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaveItemsQuery, GetLeaveItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaveItemsQuery, GetLeaveItemsQueryVariables>(GetLeaveItemsDocument, options);
        }
export type GetLeaveItemsQueryHookResult = ReturnType<typeof useGetLeaveItemsQuery>;
export type GetLeaveItemsLazyQueryHookResult = ReturnType<typeof useGetLeaveItemsLazyQuery>;
export type GetLeaveItemsQueryResult = Apollo.QueryResult<GetLeaveItemsQuery, GetLeaveItemsQueryVariables>;
export const GetWorkRecordsDocument = gql`
    query getWorkRecords {
  workRecords {
    id
    employee {
      id
      name
      code
      company {
        id
        name
      }
    }
    dayType
    startTime
    endTime
    restHours
    description
  }
}
    `;

/**
 * __useGetWorkRecordsQuery__
 *
 * To run a query within a React component, call `useGetWorkRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkRecordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkRecordsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkRecordsQuery, GetWorkRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkRecordsQuery, GetWorkRecordsQueryVariables>(GetWorkRecordsDocument, options);
      }
export function useGetWorkRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkRecordsQuery, GetWorkRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkRecordsQuery, GetWorkRecordsQueryVariables>(GetWorkRecordsDocument, options);
        }
export type GetWorkRecordsQueryHookResult = ReturnType<typeof useGetWorkRecordsQuery>;
export type GetWorkRecordsLazyQueryHookResult = ReturnType<typeof useGetWorkRecordsLazyQuery>;
export type GetWorkRecordsQueryResult = Apollo.QueryResult<GetWorkRecordsQuery, GetWorkRecordsQueryVariables>;
export const RemoveLeaveItemDocument = gql`
    mutation removeLeaveItem($id: Int!) {
  removeLeaveItem(id: $id)
}
    `;
export type RemoveLeaveItemMutationFn = Apollo.MutationFunction<RemoveLeaveItemMutation, RemoveLeaveItemMutationVariables>;

/**
 * __useRemoveLeaveItemMutation__
 *
 * To run a mutation, you first call `useRemoveLeaveItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLeaveItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLeaveItemMutation, { data, loading, error }] = useRemoveLeaveItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveLeaveItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLeaveItemMutation, RemoveLeaveItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLeaveItemMutation, RemoveLeaveItemMutationVariables>(RemoveLeaveItemDocument, options);
      }
export type RemoveLeaveItemMutationHookResult = ReturnType<typeof useRemoveLeaveItemMutation>;
export type RemoveLeaveItemMutationResult = Apollo.MutationResult<RemoveLeaveItemMutation>;
export type RemoveLeaveItemMutationOptions = Apollo.BaseMutationOptions<RemoveLeaveItemMutation, RemoveLeaveItemMutationVariables>;
export const RemoveWorkRecordDocument = gql`
    mutation removeWorkRecord($id: Int!) {
  removeWorkRecord(id: $id)
}
    `;
export type RemoveWorkRecordMutationFn = Apollo.MutationFunction<RemoveWorkRecordMutation, RemoveWorkRecordMutationVariables>;

/**
 * __useRemoveWorkRecordMutation__
 *
 * To run a mutation, you first call `useRemoveWorkRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkRecordMutation, { data, loading, error }] = useRemoveWorkRecordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveWorkRecordMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkRecordMutation, RemoveWorkRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkRecordMutation, RemoveWorkRecordMutationVariables>(RemoveWorkRecordDocument, options);
      }
export type RemoveWorkRecordMutationHookResult = ReturnType<typeof useRemoveWorkRecordMutation>;
export type RemoveWorkRecordMutationResult = Apollo.MutationResult<RemoveWorkRecordMutation>;
export type RemoveWorkRecordMutationOptions = Apollo.BaseMutationOptions<RemoveWorkRecordMutation, RemoveWorkRecordMutationVariables>;
export const UpdateLeaveDocument = gql`
    mutation updateLeave($leave: LeaveInputType!, $id: Int!) {
  updateLeave(leave: $leave, id: $id) {
    id
  }
}
    `;
export type UpdateLeaveMutationFn = Apollo.MutationFunction<UpdateLeaveMutation, UpdateLeaveMutationVariables>;

/**
 * __useUpdateLeaveMutation__
 *
 * To run a mutation, you first call `useUpdateLeaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeaveMutation, { data, loading, error }] = useUpdateLeaveMutation({
 *   variables: {
 *      leave: // value for 'leave'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateLeaveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeaveMutation, UpdateLeaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeaveMutation, UpdateLeaveMutationVariables>(UpdateLeaveDocument, options);
      }
export type UpdateLeaveMutationHookResult = ReturnType<typeof useUpdateLeaveMutation>;
export type UpdateLeaveMutationResult = Apollo.MutationResult<UpdateLeaveMutation>;
export type UpdateLeaveMutationOptions = Apollo.BaseMutationOptions<UpdateLeaveMutation, UpdateLeaveMutationVariables>;
export const UpdateLeaveItemDocument = gql`
    mutation updateLeaveItem($leaveItem: LeaveItemInputType!, $id: Int!) {
  updateLeaveItem(leaveItem: $leaveItem, id: $id) {
    id
  }
}
    `;
export type UpdateLeaveItemMutationFn = Apollo.MutationFunction<UpdateLeaveItemMutation, UpdateLeaveItemMutationVariables>;

/**
 * __useUpdateLeaveItemMutation__
 *
 * To run a mutation, you first call `useUpdateLeaveItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeaveItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeaveItemMutation, { data, loading, error }] = useUpdateLeaveItemMutation({
 *   variables: {
 *      leaveItem: // value for 'leaveItem'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateLeaveItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeaveItemMutation, UpdateLeaveItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeaveItemMutation, UpdateLeaveItemMutationVariables>(UpdateLeaveItemDocument, options);
      }
export type UpdateLeaveItemMutationHookResult = ReturnType<typeof useUpdateLeaveItemMutation>;
export type UpdateLeaveItemMutationResult = Apollo.MutationResult<UpdateLeaveItemMutation>;
export type UpdateLeaveItemMutationOptions = Apollo.BaseMutationOptions<UpdateLeaveItemMutation, UpdateLeaveItemMutationVariables>;
export const UpdateWorkRecordDocument = gql`
    mutation updateWorkRecord($workRecord: WorkRecordInputType!, $id: Int!) {
  updateWorkRecord(workRecord: $workRecord, id: $id) {
    id
  }
}
    `;
export type UpdateWorkRecordMutationFn = Apollo.MutationFunction<UpdateWorkRecordMutation, UpdateWorkRecordMutationVariables>;

/**
 * __useUpdateWorkRecordMutation__
 *
 * To run a mutation, you first call `useUpdateWorkRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkRecordMutation, { data, loading, error }] = useUpdateWorkRecordMutation({
 *   variables: {
 *      workRecord: // value for 'workRecord'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateWorkRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkRecordMutation, UpdateWorkRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkRecordMutation, UpdateWorkRecordMutationVariables>(UpdateWorkRecordDocument, options);
      }
export type UpdateWorkRecordMutationHookResult = ReturnType<typeof useUpdateWorkRecordMutation>;
export type UpdateWorkRecordMutationResult = Apollo.MutationResult<UpdateWorkRecordMutation>;
export type UpdateWorkRecordMutationOptions = Apollo.BaseMutationOptions<UpdateWorkRecordMutation, UpdateWorkRecordMutationVariables>;
export const CreateSalaryExtendDocument = gql`
    mutation createSalaryExtend($salaryExtendDto: SalaryExtendInputType!) {
  createSalaryExtend(salaryExtend: $salaryExtendDto) {
    id
  }
}
    `;
export type CreateSalaryExtendMutationFn = Apollo.MutationFunction<CreateSalaryExtendMutation, CreateSalaryExtendMutationVariables>;

/**
 * __useCreateSalaryExtendMutation__
 *
 * To run a mutation, you first call `useCreateSalaryExtendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalaryExtendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalaryExtendMutation, { data, loading, error }] = useCreateSalaryExtendMutation({
 *   variables: {
 *      salaryExtendDto: // value for 'salaryExtendDto'
 *   },
 * });
 */
export function useCreateSalaryExtendMutation(baseOptions?: Apollo.MutationHookOptions<CreateSalaryExtendMutation, CreateSalaryExtendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSalaryExtendMutation, CreateSalaryExtendMutationVariables>(CreateSalaryExtendDocument, options);
      }
export type CreateSalaryExtendMutationHookResult = ReturnType<typeof useCreateSalaryExtendMutation>;
export type CreateSalaryExtendMutationResult = Apollo.MutationResult<CreateSalaryExtendMutation>;
export type CreateSalaryExtendMutationOptions = Apollo.BaseMutationOptions<CreateSalaryExtendMutation, CreateSalaryExtendMutationVariables>;
export const CreateSalaryGroupDocument = gql`
    mutation createSalaryGroup($salaryGroup: SalaryGroupInputType!) {
  createSalaryGroup(salaryGroup: $salaryGroup) {
    id
  }
}
    `;
export type CreateSalaryGroupMutationFn = Apollo.MutationFunction<CreateSalaryGroupMutation, CreateSalaryGroupMutationVariables>;

/**
 * __useCreateSalaryGroupMutation__
 *
 * To run a mutation, you first call `useCreateSalaryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalaryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalaryGroupMutation, { data, loading, error }] = useCreateSalaryGroupMutation({
 *   variables: {
 *      salaryGroup: // value for 'salaryGroup'
 *   },
 * });
 */
export function useCreateSalaryGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateSalaryGroupMutation, CreateSalaryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSalaryGroupMutation, CreateSalaryGroupMutationVariables>(CreateSalaryGroupDocument, options);
      }
export type CreateSalaryGroupMutationHookResult = ReturnType<typeof useCreateSalaryGroupMutation>;
export type CreateSalaryGroupMutationResult = Apollo.MutationResult<CreateSalaryGroupMutation>;
export type CreateSalaryGroupMutationOptions = Apollo.BaseMutationOptions<CreateSalaryGroupMutation, CreateSalaryGroupMutationVariables>;
export const GetSalaryGroupsDocument = gql`
    query getSalaryGroups {
  salaryGroups {
    id
    company {
      id
      name
    }
    yearMonth
    title
    startDate
    endDate
    payDate
    salaries {
      id
      employee {
        id
        name
        code
      }
      salaryItems {
        id
        title
        amount
        type
      }
    }
  }
}
    `;

/**
 * __useGetSalaryGroupsQuery__
 *
 * To run a query within a React component, call `useGetSalaryGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalaryGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalaryGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalaryGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetSalaryGroupsQuery, GetSalaryGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalaryGroupsQuery, GetSalaryGroupsQueryVariables>(GetSalaryGroupsDocument, options);
      }
export function useGetSalaryGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalaryGroupsQuery, GetSalaryGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalaryGroupsQuery, GetSalaryGroupsQueryVariables>(GetSalaryGroupsDocument, options);
        }
export type GetSalaryGroupsQueryHookResult = ReturnType<typeof useGetSalaryGroupsQuery>;
export type GetSalaryGroupsLazyQueryHookResult = ReturnType<typeof useGetSalaryGroupsLazyQuery>;
export type GetSalaryGroupsQueryResult = Apollo.QueryResult<GetSalaryGroupsQuery, GetSalaryGroupsQueryVariables>;
export const GetSalariesDocument = gql`
    query getSalaries {
  salaries {
    id
    updatedAt
    salaryGroup {
      yearMonth
      title
      startDate
      endDate
    }
    employee {
      code
      name
      company {
        id
        name
      }
    }
    salaryItems {
      title
      amount
      type
    }
  }
}
    `;

/**
 * __useGetSalariesQuery__
 *
 * To run a query within a React component, call `useGetSalariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalariesQuery(baseOptions?: Apollo.QueryHookOptions<GetSalariesQuery, GetSalariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalariesQuery, GetSalariesQueryVariables>(GetSalariesDocument, options);
      }
export function useGetSalariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalariesQuery, GetSalariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalariesQuery, GetSalariesQueryVariables>(GetSalariesDocument, options);
        }
export type GetSalariesQueryHookResult = ReturnType<typeof useGetSalariesQuery>;
export type GetSalariesLazyQueryHookResult = ReturnType<typeof useGetSalariesLazyQuery>;
export type GetSalariesQueryResult = Apollo.QueryResult<GetSalariesQuery, GetSalariesQueryVariables>;
export const GetSalaryExtendsDocument = gql`
    query getSalaryExtends {
  salaryExtends {
    id
    employee {
      id
      name
      code
      company {
        id
        name
      }
    }
    yearMonth
    subject
    amount
    description
    type
  }
}
    `;

/**
 * __useGetSalaryExtendsQuery__
 *
 * To run a query within a React component, call `useGetSalaryExtendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalaryExtendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalaryExtendsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalaryExtendsQuery(baseOptions?: Apollo.QueryHookOptions<GetSalaryExtendsQuery, GetSalaryExtendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalaryExtendsQuery, GetSalaryExtendsQueryVariables>(GetSalaryExtendsDocument, options);
      }
export function useGetSalaryExtendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalaryExtendsQuery, GetSalaryExtendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalaryExtendsQuery, GetSalaryExtendsQueryVariables>(GetSalaryExtendsDocument, options);
        }
export type GetSalaryExtendsQueryHookResult = ReturnType<typeof useGetSalaryExtendsQuery>;
export type GetSalaryExtendsLazyQueryHookResult = ReturnType<typeof useGetSalaryExtendsLazyQuery>;
export type GetSalaryExtendsQueryResult = Apollo.QueryResult<GetSalaryExtendsQuery, GetSalaryExtendsQueryVariables>;
export const CalculateSalariesDocument = gql`
    query calculateSalaries($yearMonth: String!, $startDate: DateTime!, $endDate: DateTime!, $companyId: Int!) {
  calculateSalaries(
    yearMonth: $yearMonth
    startDate: $startDate
    endDate: $endDate
    companyId: $companyId
  ) {
    employee {
      id
      name
      code
      arrivalDate
      leaveDate
      type
    }
    salaryItems {
      title
      amount
      type
    }
  }
}
    `;

/**
 * __useCalculateSalariesQuery__
 *
 * To run a query within a React component, call `useCalculateSalariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateSalariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateSalariesQuery({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCalculateSalariesQuery(baseOptions: Apollo.QueryHookOptions<CalculateSalariesQuery, CalculateSalariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateSalariesQuery, CalculateSalariesQueryVariables>(CalculateSalariesDocument, options);
      }
export function useCalculateSalariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateSalariesQuery, CalculateSalariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateSalariesQuery, CalculateSalariesQueryVariables>(CalculateSalariesDocument, options);
        }
export type CalculateSalariesQueryHookResult = ReturnType<typeof useCalculateSalariesQuery>;
export type CalculateSalariesLazyQueryHookResult = ReturnType<typeof useCalculateSalariesLazyQuery>;
export type CalculateSalariesQueryResult = Apollo.QueryResult<CalculateSalariesQuery, CalculateSalariesQueryVariables>;
export const RemoveSalaryExtendDocument = gql`
    mutation removeSalaryExtend($id: Int!) {
  removeSalaryExtend(id: $id)
}
    `;
export type RemoveSalaryExtendMutationFn = Apollo.MutationFunction<RemoveSalaryExtendMutation, RemoveSalaryExtendMutationVariables>;

/**
 * __useRemoveSalaryExtendMutation__
 *
 * To run a mutation, you first call `useRemoveSalaryExtendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSalaryExtendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSalaryExtendMutation, { data, loading, error }] = useRemoveSalaryExtendMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveSalaryExtendMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSalaryExtendMutation, RemoveSalaryExtendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSalaryExtendMutation, RemoveSalaryExtendMutationVariables>(RemoveSalaryExtendDocument, options);
      }
export type RemoveSalaryExtendMutationHookResult = ReturnType<typeof useRemoveSalaryExtendMutation>;
export type RemoveSalaryExtendMutationResult = Apollo.MutationResult<RemoveSalaryExtendMutation>;
export type RemoveSalaryExtendMutationOptions = Apollo.BaseMutationOptions<RemoveSalaryExtendMutation, RemoveSalaryExtendMutationVariables>;
export const RemoveSalaryGroupDocument = gql`
    mutation removeSalaryGroup($id: Int!) {
  removeSalaryGroup(id: $id)
}
    `;
export type RemoveSalaryGroupMutationFn = Apollo.MutationFunction<RemoveSalaryGroupMutation, RemoveSalaryGroupMutationVariables>;

/**
 * __useRemoveSalaryGroupMutation__
 *
 * To run a mutation, you first call `useRemoveSalaryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSalaryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSalaryGroupMutation, { data, loading, error }] = useRemoveSalaryGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveSalaryGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSalaryGroupMutation, RemoveSalaryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSalaryGroupMutation, RemoveSalaryGroupMutationVariables>(RemoveSalaryGroupDocument, options);
      }
export type RemoveSalaryGroupMutationHookResult = ReturnType<typeof useRemoveSalaryGroupMutation>;
export type RemoveSalaryGroupMutationResult = Apollo.MutationResult<RemoveSalaryGroupMutation>;
export type RemoveSalaryGroupMutationOptions = Apollo.BaseMutationOptions<RemoveSalaryGroupMutation, RemoveSalaryGroupMutationVariables>;
export const SendSalariesDocument = gql`
    mutation sendSalaries($subject: String!, $body: String!, $salaryIds: [Int!]!) {
  sendSalaries(subject: $subject, body: $body, salaryIds: $salaryIds)
}
    `;
export type SendSalariesMutationFn = Apollo.MutationFunction<SendSalariesMutation, SendSalariesMutationVariables>;

/**
 * __useSendSalariesMutation__
 *
 * To run a mutation, you first call `useSendSalariesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSalariesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSalariesMutation, { data, loading, error }] = useSendSalariesMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      salaryIds: // value for 'salaryIds'
 *   },
 * });
 */
export function useSendSalariesMutation(baseOptions?: Apollo.MutationHookOptions<SendSalariesMutation, SendSalariesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSalariesMutation, SendSalariesMutationVariables>(SendSalariesDocument, options);
      }
export type SendSalariesMutationHookResult = ReturnType<typeof useSendSalariesMutation>;
export type SendSalariesMutationResult = Apollo.MutationResult<SendSalariesMutation>;
export type SendSalariesMutationOptions = Apollo.BaseMutationOptions<SendSalariesMutation, SendSalariesMutationVariables>;
export const UpdateSalaryExtendDocument = gql`
    mutation updateSalaryExtend($salaryExtendDto: SalaryExtendInputType!, $id: Int!) {
  updateSalaryExtend(salaryExtend: $salaryExtendDto, id: $id) {
    id
  }
}
    `;
export type UpdateSalaryExtendMutationFn = Apollo.MutationFunction<UpdateSalaryExtendMutation, UpdateSalaryExtendMutationVariables>;

/**
 * __useUpdateSalaryExtendMutation__
 *
 * To run a mutation, you first call `useUpdateSalaryExtendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalaryExtendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalaryExtendMutation, { data, loading, error }] = useUpdateSalaryExtendMutation({
 *   variables: {
 *      salaryExtendDto: // value for 'salaryExtendDto'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateSalaryExtendMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalaryExtendMutation, UpdateSalaryExtendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalaryExtendMutation, UpdateSalaryExtendMutationVariables>(UpdateSalaryExtendDocument, options);
      }
export type UpdateSalaryExtendMutationHookResult = ReturnType<typeof useUpdateSalaryExtendMutation>;
export type UpdateSalaryExtendMutationResult = Apollo.MutationResult<UpdateSalaryExtendMutation>;
export type UpdateSalaryExtendMutationOptions = Apollo.BaseMutationOptions<UpdateSalaryExtendMutation, UpdateSalaryExtendMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($user: CreateUserDto!) {
  createUser(user: $user) {
    id
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const GetUsersDocument = gql`
    query getUsers {
  users {
    id
    name
    email
    roles
    picture
    disabled
    companies {
      id
      name
    }
    authorizations
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetMeDocument = gql`
    query getMe {
  me {
    id
    name
    email
    roles
    picture
    companies {
      id
      name
      contractors {
        id
        name
        phone
        email
        address
        idNumber
        taxClassification
        contactAddress
        bankCode
        bankAccountNumber
        bankAccountName
        nationality
        noInsurance
      }
      reports {
        id
        name
        uri
      }
      companyAuthorizations {
        id
        authorization
        startDate
        endDate
        remindDate
        enabled
      }
    }
    authorizations
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const RemoveUserDocument = gql`
    mutation removeUser($id: Int!) {
  removeUser(id: $id)
}
    `;
export type RemoveUserMutationFn = Apollo.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($user: UpdateUserDto!, $id: Int!) {
  updateUser(user: $user, id: $id) {
    id
    name
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;